module.exports = __webpack_public_path__ + "static/img/sb1.7bb1d27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sb1.png
// module id = qaTf
// module chunks = 9